function checkIfSupported() {
    try {
        let supported =  'localStorage' in window && window['localStorage'] !== null && window.localStorage;
        window.localStorage.setItem('musico-test','test');
        window.localStorage.removeItem('musico-test');
        return supported;
    } catch (e) {
        return false;
    }
}

const isSupported = checkIfSupported();
export let storageStore = {
    setItem: function (id, val) {
        return storageStore[id] = String(val);
    },
    getItem: function (id) {
        return storageStore.hasOwnProperty(id) ? String(storageStore[id]) : undefined;
    },
    removeItem: function (id) {
        return delete storageStore[id];
    },
    clear: function () {
        storageStore = {};
    }
};

export function getStorage() {
    if (isSupported) {
        return window.localStorage;
    } else {
        return storageStore;
    }
}


